import { useTranslation } from "react-i18next";

import UploadButton from "../../../../components/UploadButton";
import useSingleFileUpload from "../../../ui/hooks/useSingleFileUpload";

import useFormField from "../../hooks/useFormField";

export default function FormUploadButton({ path, bucketName, text, ...props }) {
	const { t } = useTranslation();
	const { field } = useFormField(props);
	const { value, onChange } = field;

	const [{ loading: uploading, error }, onUploadFile] = useSingleFileUpload({
		bucketName,
		getDestination: (file) => `${path}/${Date.now()}.${file.name.split(".").pop()}`,
		onSuccess: (fileData) => onChange(null, { value: fileData }),
	});

	return (
		<UploadButton
			loading={uploading}
			onUpload={onUploadFile}
			text={
				error
					? t("uploadFailed", "Upload failed, try again")
					: value
					? t("fileUploaded", "File uploaded")
					: text || t("selectFile", "Select file")
			}
			icon={error ? "warning circle" : value ? "check" : "upload"}
			color={error ? "red" : value ? "green" : undefined}
			style={{ whiteSpace: "nowrap" }}
		/>
	);
}
